import React from 'react';
import { Box } from '@mui/material';

type PageContainerProps = {
  children: React.ReactNode;
  component?: React.ElementType;
};

/** Centers page content on a consistent measure. */
const PageContainer = ({ children, component = 'div' }: PageContainerProps) => {
  return (
    <Box
      component={component}
      sx={{
        width: 'min(1120px, calc(100% - 2.5rem))',
        mx: 'auto',
        py: { xs: 5, md: 8 },
      }}
    >
      {children}
    </Box>
  );
};

export default PageContainer;
